/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/login.scss';
import {ChangeKeyFunction, Link} from '@dvrd/dvr-controls';

import {CredentialResponse} from '@react-oauth/google';

import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler, useRef, useState} from 'react';

import {REGISTER_ROUTE} from '../../../util/constants';

import {LoginErrors} from '../../../util/interfaces';

import Image from '../../misc/image';

import LoginForm from './loginForm';

import {useTranslation} from 'react-i18next';

interface Props {
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onChange: ChangeKeyFunction<string>;
    onFocusField: (key: keyof LoginErrors) => FocusEventHandler;
    onClickRegister: MouseEventHandler;
    onGoogleLogin: (response: CredentialResponse) => void;
    onGoogleError: () => void;
    onClickGoogle: MouseEventHandler;
    onClickReset: MouseEventHandler;
    email: string;
    password: string;
    loading: boolean;
    errors: LoginErrors;
}

export default function Login(props: Props) {
    const {onClickRegister, ...formProps} = props;
    const {t} = useTranslation();
    const [headerHeight, setHeaderHeight] = useState(0);
    const headerRef = useRef<HTMLDivElement>(null);

    function _setHeaderHeight() {
        if (!headerRef.current) return;
        setHeaderHeight(headerRef.current.getBoundingClientRect().height);
    }

    return (
        <div className='login'>
            <div className='logo-header' ref={headerRef}>
                <Image name='logo' className='logo' onLoad={_setHeaderHeight} />
            </div>
            <div style={{height: `${headerHeight}px`}} />
            <div>
                <div className='header-container'>
                    <h1 className='header-title'>{t('auth.login.title', 'Inloggen in je account')}</h1>
                    <label className='sub-title'>{t('auth.login.subtitle', 'Welkom bij Bluemate')}</label>
                </div>
                <LoginForm {...formProps} />
                <label className='register-label'>
                    {t('auth.login.noAccount', 'Heb je nog geen account?')}{' '}
                    <Link route={REGISTER_ROUTE} onClick={onClickRegister} underline>
                        {t('auth.login.register', 'Registreren')}
                    </Link>
                </label>
            </div>
        </div>
    );
}
